<div class="modal-header">
    <h4 class="modal-title">{{'midtermExamPayment_detailsTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <div class="block-em">
        <div class="row">
            <div class="data-value col-md-6">
                <label>{{'midtermExamPayment_lblStatus' | translate}}</label>
                <div>
                    <app-midterm-exam-payment-status [value]="data?.Status"></app-midterm-exam-payment-status>
                </div>
            </div>

            <div class="data-value col-md-6">
                <label>{{'midtermExamPayment_lblAmount' | translate}}</label>
                <div>{{data?.Amount | number:'1.2-2':'en-US'}}</div>
            </div>

            <div class="data-value col-md-6">
                <label>{{'midtermExamPayment_lblCreated' | translate}}</label>
                <div>{{data?.Created | appDate:'datetime'}}</div>
            </div>

            <div class="data-value col-md-6">
                <label>{{'midtermExamPayment_lblModified' | translate}}</label>
                <div>{{data?.Modified | appDate:'datetime'}}</div>
            </div>
        </div>
    </div>

    <div class="data-value">
        <label>{{'midtermExamPayment_lblCourse' | translate}}</label>
        <div>{{data?.CourseName}} ({{data?.CourseCode}})</div>
    </div>

    <div class="data-value">
        <label>{{'midtermExamPayment_lblSemester' | translate}}</label>
        <div>{{data?.Semester}}</div>
    </div>

    <div class="data-value">
        <label>{{'midtermExamPayment_lblStudent' | translate}}</label>
        <div>{{data?.StudentFullName}} ({{data?.StudentUpn}})</div>
    </div>

    <div class="data-value">
        <label>{{'midtermExamPayment_lblTeacher' | translate}}</label>
        <div>{{data?.TeacherFullName}}</div>
    </div>

    <div class="data-value">
        <label>{{'midtermExamPayment_lblReason' | translate}}</label>
        <div>{{data?.Reason}}</div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="close()">{{'close' | translate}}</button>
    <button type="button" class="btn btn-primary" (click)="add()" *ngIf="canAdd">{{'midtermExamPayment_btnNewPayment' | translate}}</button>
</div>
